import {
  collection,
  getDocs,
  getDoc,
  doc,
  addDoc,
  updateDoc,
  deleteDoc,
  serverTimestamp,
  query,
  orderBy,
} from "firebase/firestore";
import { db } from "./config";
import { logFirestoreOperation } from "./debugHelper";

// Get all projects
export const getProjects = async () => {
  try {
    const projectsQuery = query(
      collection(db, "projects"),
      orderBy("createdAt", "desc")
    );
    const querySnapshot = await getDocs(projectsQuery);

    return querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
  } catch (error) {
    console.error("Error getting projects:", error);
    throw error;
  }
};

// Get a single project by ID
export const getProject = async (projectId) => {
  try {
    const projectDoc = await getDoc(doc(db, "projects", projectId));
    if (projectDoc.exists()) {
      return {
        id: projectDoc.id,
        ...projectDoc.data(),
      };
    } else {
      console.log("No project found with ID:", projectId);
      return null;
    }
  } catch (error) {
    console.error("Error getting project:", error);
    throw error;
  }
};

// Add a new project
export const addProject = async (projectData) => {
  try {
    const newProject = {
      ...projectData,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    };

    logFirestoreOperation("addDoc", "projects", newProject);
    const docRef = await addDoc(collection(db, "projects"), newProject);
    return docRef.id;
  } catch (error) {
    console.error("Error adding project:", error);
    throw error;
  }
};

// Update an existing project
export const updateProject = async (projectId, projectData) => {
  try {
    const updatedData = {
      ...projectData,
      updatedAt: serverTimestamp(),
    };

    logFirestoreOperation("updateDoc", `projects/${projectId}`, updatedData);
    await updateDoc(doc(db, "projects", projectId), updatedData);
    return projectId;
  } catch (error) {
    console.error("Error updating project:", error);
    throw error;
  }
};

// Delete a project
export const deleteProject = async (projectId) => {
  try {
    logFirestoreOperation("deleteDoc", `projects/${projectId}`);
    await deleteDoc(doc(db, "projects", projectId));
    return projectId;
  } catch (error) {
    console.error("Error deleting project:", error);
    throw error;
  }
};
